module.exports = __webpack_public_path__ + "img/cloud1.705d7af0.png";